import { Pagination } from '@mui/material';
import { useRef, useState } from 'react';
import '../common-css/Table.css';
import { showTableResponse } from '../common-helpers/commonServices';
import UGC_TestManagementModal from './UGC_TestManagementModal';

const UGC_TestManagement = () => {
    const childRef = useRef();
    const [subjects, setSubjects] = useState([
        { Sn: 0, examType: 'GENERAL APTITUDE' },
        { Sn: 1, examType: 'SUBJECT SPECIFIC' },
        { Sn: 2, examType: 'COMBINED' }
    ]);
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(subjects);
    const [loadSubjects, setSubjectLoading] = useState(false);
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">
                                <div className='dataTables_info text-dark'>
                                    Records: {checked.length}
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                <th className=' custom-table-header p-2' style={{ width: "50px" }}>Sl.No.</th>
                                                <th className=' custom-table-header p-2 text-start'>SECTIONS</th>
                                                <th className=' custom-table-header p-2 text-start'>MANAGE QUESTIONS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "50px" }}>
                                                        <h6 className="mb-0 ">
                                                            {ind + 1 + firstIndex}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-statt' style={{ border: "1px solid #cccccc" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.examType === "GENERAL APTITUDE" ? "Teaching & Research Aptitude" : item.examType === "SUBJECT SPECIFIC" ? "Academic Subjects" : item.examType === "COMBINED" ? "COMBINED TESTS" : item.examType}
                                                        </h6>
                                                    </td>
                                                    <td className="p-1 text-center" style={{ border: "1px solid #ccc", width: "85px" }}>
                                                        <button onClick={() => childRef.current.openModal(item.examType)} className="btn btn-xs btn-info">Manage</button>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(subjects, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UGC_TestManagementModal ref={childRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
        </>
    )
}

export default UGC_TestManagement;
